import { RouteObject } from "react-router-dom";
import { GeneralErrorPage } from "@songtradr-sso/shared/frontend";
import { SignUp } from "./SignUp";
import { routes } from "./SignUp.Parts";

// LOADER

// WRAPPER

// ROUTE
export const SignUpRouteObject: RouteObject = {
  path: routes.signUp,
  errorElement: <GeneralErrorPage />,
  Component: SignUp,
};
